import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "default-btn outlined transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#discard-modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", _hoisted_1, _toDisplayString(_ctx.$t('cta.discard')), 1 /* TEXT */),
    _createVNode(_component_ConfirmModal, {
      id: "discard-modal",
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirm())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$discard.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}